//alert(true);
import './styles.editor.scss';
import { registerBlockType } from '@wordpress/blocks';
import ServerSideRender from '@wordpress/server-side-render';
import { __ } from '@wordpress/i18n';
import { Component, useState, useEffect, Fragment } from '@wordpress/element';
import IconWishListMember from '../icons/icon-wishlist-member';
import {
	Toolbar,
	ToolbarGroup,
	ToolbarItem,
	DropdownMenu,
	PanelBody,
	ToggleControl,
	Button,
	TextControl,
	Disabled,
	SelectControl,
} from '@wordpress/components';
import { RadioControl } from '@wordpress/components';
import { __experimentalNumberControl as NumberControl } from '@wordpress/components';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import Loading from '../loading';

registerBlockType('wishlist-box-basic-blocks/access-userpayperpost', {
	title: __('User Pay Per Posts', 'wishlist-member'),
	description: __('Display Access User Pay Per Posts', 'wishlist-box-basic'),
	category: 'wishlist-box-basic-blocks-category',
	keywords: [__('wlm'), __('member'), __('access')],
	icon: IconWishListMember,
	attributes: {
		content: {
			type: 'string',
			default: '[wlm_userpayperpost sort="ascending"]',
		},
		sort: {
			type: 'string',
			default: 'ascending',
		},
		sortby: {
			type: 'string',
			default: 'date-assigned',
		},
		liststyletype: {
			type: 'string',
			default: 'inherit',
		},
		total: {
			type: 'int',
			default: 5,
		},
		totalshowmore: {
			type: 'int',
			default: 3,
		},
		showmoretext: {
			type: 'string',
			default: 'Show More...',
		},
		buttonstyle: {
			type: 'string',
			default: 'button',
		},
		ineditor: {
			type: 'boolean',
			default: false,
		},
	},
	edit(props) {
		const { attributes, setAttributes } = props;
		const blockProps = useBlockProps();
		// const [totalInEditor, setTotalInEditor] = useState(2);

		const content = attributes.content;
		const sort = attributes.sort;
		const sortby = attributes.sortby;
		const liststyletype = attributes.liststyletype;
		const total = attributes.total;
		const showmoretext = attributes.showmoretext;
		const totalshowmore = attributes.totalshowmore;
		const buttonstyle = attributes.buttonstyle;

		const onChangesort = (value) => {
			setAttributes({ sort: value });
		};
		const onChangesortby = (value) => {
			setAttributes({ sortby: value });
		};
		const onChangeliststyletype = (value) => {
			setAttributes({ liststyletype: value });
		};
		const onChangetotal = (value) => {
			setAttributes({ total: value });
		};
		const onChangetotalshowmore = (value) => {
			setAttributes({ totalshowmore: value });
		};
		const onChangeshowmoretext = (value) => {
			setAttributes({ showmoretext: value });
		};
		const onChangebuttonstyle = (value) => {
			setAttributes({ buttonstyle: value });
		};

		if (content === null) {
			(sort) => {
				onChangesort(sort);
			};
		}

		const output = (
			<Fragment>
				<ServerSideRender
					block="wishlist-box-basic-blocks/access-userpayperpost"
					// attributes={ attributes }
					httpMethod="POST"
					LoadingResponsePlaceholder={Loading}
					attributes={{
						sort: attributes.sort,
						sortby: attributes.sortby,
						liststyletype: attributes.liststyletype,
						total: attributes.total,
						showmoretext: attributes.showmoretext,
						totalshowmore: attributes.totalshowmore,
						buttonstyle: attributes.buttonstyle,
						ineditor: true,
					}}
				/>
			</Fragment>
		);

		useEffect(() => {}, [
			content,
			sort,
			sortby,
			buttonstyle,
			liststyletype,
			total,
			showmoretext,
			totalshowmore,
			output,
		]);

		return (
			<div>
				<InspectorControls>
					<PanelBody title={__('Options', 'wishlist-member')}>
						<RadioControl
							className="wishlistmember-mergecodes-radiocontrol"
							label="Sort By"
							selected={sortby}
							options={[
								{
									label: 'Date Assigned',
									value: 'date-assigned',
								},
								{
									label: 'Date Published',
									value: 'date-published',
								},
								{ label: 'Post Title', value: 'post-title' },
							]}
							onChange={(sortby) => {
								onChangesortby(sortby);
							}}
						/>
						<RadioControl
							className="wishlistmember-mergecodes-radiocontrol"
							label="Sort Order"
							selected={sort}
							options={[
								{
									label:
										sortby === 'post-title'
											? __('Ascending', 'wishlist-member')
											: __('Oldest', 'wishlist-member'),
									value: 'ascending',
								},
								{
									label:
										sortby === 'post-title'
											? __(
													'Descending',
													'wishlist-member'
											  )
											: __('Newest', 'wishlist-member'),
									value: 'descending',
								},
							]}
							onChange={(sort) => {
								onChangesort(sort);
							}}
						/>
						<SelectControl
							className="wishlistmember-mergecodes-selectcontrol"
							label="List Style Type"
							selected={liststyletype}
							options={[
								{
									label: __(
										'Default (Theme Styled)',
										'wishlist-member'
									),
									value: 'inherit',
								},
								{
									label: __(
										'Bulleted List',
										'wishlist-member'
									),
									value: 'disc',
								},
								{
									label: __('Square List', 'wishlist-member'),
									value: 'square',
								},
								{
									label: __(
										'Numbered List',
										'wishlist-member'
									),
									value: 'decimal',
								},
								{
									label: __('No Style', 'wishlist-member'),
									value: 'none',
								},
							]}
							onChange={(liststyletype) => {
								onChangeliststyletype(liststyletype);
							}}
						/>
						<NumberControl
							min={-1}
							label={__(
								'Number of Posts to Display',
								'wishlist-member'
							)}
							isDragEnabled={true}
							required={true}
							isShiftStepEnabled={true}
							onChange={onChangetotal}
							shiftStep={10}
							value={total}
						/>
						<div>(-1 = All)</div>

						{total != -1 && (
							<Fragment>
								<p></p>
								<NumberControl
									min={-1}
									label={__(
										'Additional Number of Posts to Display',
										'wishlist-member'
									)}
									isDragEnabled={true}
									required={true}
									isShiftStepEnabled={true}
									onChange={onChangetotalshowmore}
									shiftStep={10}
									value={totalshowmore}
								/>
								<div>(-1 = All)</div>
								<p></p>
								{totalshowmore != 0 && (
									<Fragment>
										<TextControl
											label={__(
												'Show More Text',
												'wishlist-member'
											)}
											value={showmoretext}
											onChange={(value) =>
												onChangeshowmoretext(value)
											}
										/>
										<p></p>
										<RadioControl
											className="wishlistmember-mergecodes-radiocontrol"
											label={__(
												'Button Style',
												'wishlist-member'
											)}
											selected={buttonstyle}
											options={[
												{
													label: __(
														'Button',
														'wishlist-member'
													),
													value: 'button',
												},
												{
													label: __(
														'Link',
														'wishlist-member'
													),
													value: 'link',
												},
											]}
											onChange={(buttonstyle) => {
												onChangebuttonstyle(
													buttonstyle
												);
											}}
										/>
									</Fragment>
								)}
							</Fragment>
						)}
					</PanelBody>
				</InspectorControls>

				<div {...blockProps}>
					<Disabled>{output}</Disabled>
				</div>
			</div>
		);
	},
	save(props) {
		return null;
	},
});
